var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"error-page"},[_c('img',{attrs:{"src":require("@/assets/img/404.png"),"alt":""}}),_c('h3',[_vm._v("当前页面似乎受到三体射线的干扰")])])])
}]

export { render, staticRenderFns }